export const FINALITY_INSPECTION = {
  location_entry: 'Entrada',
  location_exit: 'Saida',
  location_comparation: 'Comparação'
};
